import { render, staticRenderFns } from "./ProducerSalesReportFiling.vue?vue&type=template&id=1dc86dcb&scoped=true&"
import script from "./ProducerSalesReportFiling.vue?vue&type=script&lang=js&"
export * from "./ProducerSalesReportFiling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc86dcb",
  null
  
)

export default component.exports